import { useNavigate, useLocation, Link } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';
import styles from './LoginPage.module.css';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import Logo from '../components/Logo';

export default function LoginPage() {
  useDocumentMeta({ title: '로그인', noIndex: true });
  const navigate = useNavigate();
  const location = useLocation();

  // 저장을 누르다 로그인한 사람을 홈으로 보내면 지켜둔 맥락이 마지막에 깨진다.
  const from = location.state?.from ?? '/';

  return (
    <div className={styles.page}>      <div className={styles.card}>
        <Link className={styles.logo} to="/"><Logo height={26} /></Link>

        <h1 className={styles.heading}>로그인</h1>

        <LoginForm onSuccess={() => navigate(from, { replace: true })} />

        <p className={styles.signupHint}>
          아직 계정이 없으신가요?{' '}
          <Link to="/signup" state={{ from }} className={styles.signupLink}>회원가입</Link>
        </p>

        <div className={styles.links}>
          <Link className={styles.link} to="/reset-password">계정찾기</Link>
          <span className={styles.linkDivider} aria-hidden="true" />
          <Link className={styles.link} to="/">로그인 없이 둘러보기</Link>
        </div>
      </div>
    </div>
  );
}
